import React from "react";
import ReactDOM from "react-dom/client";
// DO NOT move env import - should always come before App
import "./env.ts";
import App from "./App.tsx";
import "./index.css";
import { initExternalIntegrations } from "./integrations";
import { logger } from "./services/telemetry";

// Init analytics after env is populated (reads VITE_AMPLITUDE_API_KEY), before render.
initExternalIntegrations();

// Catch errors that escape React's tree — uncaught exceptions and unhandled
// promise rejections — so they reach OTEL instead of only the console. React
// render errors are handled separately by ErrorBoundary.
window.addEventListener("error", (event) => {
  logger.error(
    event.error instanceof Error ? event.error : new Error(event.message),
    "uncaught error",
  );
});
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  logger.error(
    reason instanceof Error ? reason : new Error(String(reason)),
    "unhandled promise rejection",
  );
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
